<template>
    <div class='loader' :class="{'loader-fill': fill, [size]: size != '', [color]: color != ''}">
      <div class='spinner-wrapper'>
          <div class='spinner'></div>
          <div class='spinner-inner'>
              <img src="@/assets/img/spinner-icon.svg" />
          </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fill: Boolean,
    size: String,
    color: String
  },
  name: 'AppLoader',
  setup() {
    return {}
  }
})
</script>

<style scoped lang='scss'>


    .loader {
        display: inline-flex;
        justify-content: center;
        align-items: center;

        &.small {
          .spinner-wrapper {
            height: 1.5rem;
            width: 1.5rem;
            border: 0;
            .spinner-inner {
              img {
                display: none;
              }
            }
          }
        }

        &.white {
          .spinner {
            border-color: white !important;
            border-top-color: transparent !important;
          }
        }

        &.loader-fill {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }

        .spinner-wrapper {
            height: 4rem;
            width: 4rem;
            border-radius: 100%;
            //background: white;
            position: relative;

            .spinner {
                height: 100%;
                width: 100%;
                border-radius: 100%;
                border: 2px solid var(--color-primary);
                border-top-color: transparent;
                animation: spin 0.5s linear infinite;
            }

            .spinner-inner {
                position: absolute;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                animation: fadeIn 1s linear;
                animation-fill-mode: forwards;

                img {
                    height: 32px;
                }
            }

        }

    }
</style>
